export default __webpack_public_path__ + "static/media/pictogramBeaconUtilityGas64.13785e30.svg";